"use client";

import { cn } from "@/lib/utils";

export function ComposeDivider({
  className,
  compact = false,
}: {
  className?: string;
  compact?: boolean;
}) {
  return (
    <div
      aria-hidden
      className={cn(
        "h-px",
        compact ? "mx-2 mt-1.5 sm:mx-2.5" : "mx-3 mt-2.5 sm:mx-4 sm:mt-3",
        className
      )}
      style={{
        background:
          "linear-gradient(to right, transparent, rgba(203,213,225,0.60) 25%, rgba(203,213,225,0.60) 75%, transparent)",
      }}
    />
  );
}
